import * as LayoutSelectors from './layout.selectors';
import * as OperadorasSelectors from './operadoras.selectors';
import * as UserProfileSelectors from './user-profile.selectors';
import * as RouterSelectors from './router.selectors';

export { LayoutSelectors, OperadorasSelectors, UserProfileSelectors, RouterSelectors };
